<bb-tabs></bb-tabs>
<bb-heading-container></bb-heading-container>
<bb-render-html [path]="path" (rendered)="onRendered()"></bb-render-html>
